type AttributeOption = {
    value?: string;
    range?: {
        minimum: string | number;
        maximum: string | number;
        increment: string | number;
    };
};

export const getDefaultForAttributeValues = (
    options: AttributeOption[],
    defaultValue: string,
): Record<string, string> => {
    const defaultValues: Record<string, string> = {};

    options.forEach((eachOption) => {
        if (eachOption.value) {
            defaultValues[eachOption.value] = defaultValue;
        } else if (eachOption.range) {
            const range = eachOption.range;
            // if the range is only 5 or less values use them as if they are string values
            // ignore ranges with more than 5 values for now
            // this logic is need as deco location attribute could use range value 0 - 1 as its values
            if ((+range.maximum - +range.minimum) / +range.increment <= 5) {
                for (
                    let i = parseInt(String(range.minimum));
                    i <= parseInt(String(range.maximum));
                    i += parseInt(String(range.increment))
                ) {
                    defaultValues[i.toString()] = defaultValue;
                }
            }
        }
    });

    return defaultValues;
};
